import { departmentService } from '../../../../../../../utils/constants/callService'
import { Roles } from '../../../../../../../utils/enums'
import { Item } from '../../../../../../../utils/types/generals'
import { Recive } from '../../../typing'

const submit = async ({
  data,
  userFolioSelected,
  userSelected,
  userTable,
  id,
  finish
}: {
  finish?: boolean
  id?: number | string
  data: Record<string, any>
  userTable: {
    [x: string]: any;
  }[]
  userFolioSelected: Record<
    string,
    {
      status: boolean
      reassignFolio?: boolean
      hierarchy?: boolean
      settings?:
      | {
        users: Item[]
        usersTypes: Item[]
        stores: Item[]
      }
      | undefined
    }
  >
  userSelected: Record<string, boolean>
}) => {
  let body: {
    name: string
    phone: string
    email: string
    userManageId: number[]
    users: (
      | {
        userId: number
        allFolios: boolean
        receive: {
          model: string
          modelId: number
        }[]
      }
      | {
        userId: number
        allFolios: boolean
        receive?: undefined
      }
    )[]
  } = {
    name: data?.name || null,
    ...(data?.phone && { phone: data?.phone }),
    ...(data?.email && { email: data?.email }),
    userManageIds: data?.responsible?.map(item => item.value) || [],
    users: [],
  }

  if (!!Object.values(userFolioSelected)?.length) {
    const users = Object.entries(userFolioSelected)

    body = {
      ...!finish && { ...body },
      ...finish && {
        users: users?.filter(([key]) => !!userSelected[key])?.map(([key, itemUser]) => {
          const settings = itemUser?.settings
          const reassing = itemUser?.reassignFolio === undefined ? userTable?.find(itemUserFound => itemUserFound?.id == key)?.role == (Roles.SUPERVISOR || Roles.GERENT) : itemUser?.reassignFolio
          const stores = settings?.stores ?? []
          const users = settings?.users ?? []
          const userTypes = settings?.usersTypes ?? []

          const existSetting = !!stores?.length || !!users?.length || !!userTypes?.length

          return {
            userId: parseInt(key),
            canReassign: reassing,
            historic: !!itemUser?.status,
            hierarchy: !!itemUser?.hierarchy,
            receive: !itemUser?.status && existSetting ? [
              ...stores?.map((itemStores) => ({
                model: Recive.STORE,
                modelId: itemStores.value,
              })),
              ...users?.map((itemStores) => ({
                model: Recive.USER,
                modelId: itemStores.value,
              })),
              ...userTypes?.map((itemStores) => ({
                model: Recive.USER_TYPE,
                modelId: itemStores.value,
              })),
            ] : [],
          }
        })
      }
      ,
    }
  } else {
    body = {
      ...!finish && { ...body },
      ...finish && {
        users: Object.entries(userSelected ?? {})
          ?.filter(([_, itemUser]) => !!itemUser)
          ?.map(([key]) => ({
            userId: parseInt(key),
            historic: true,
            hierarchy: false,
            canReassign: userTable?.find(itemUserFound => itemUserFound?.id == key)?.role == (Roles.SUPERVISOR || Roles.GERENT)
          })),
      }
    }
  }
  // return true
  if (finish) { return departmentService.permissionDepartment(body, id as number) }
  if (!!id) {
    return await departmentService.updateDepartment(body, id as number)
  }
  return await departmentService.createDepartment(body)
}

export { submit }